import "slick-carousel/slick/slick";
import { initWowLibrary } from "@/scripts/helpers/wowAnimation";
import MicroModal from "micromodal";
import { getScrollBarWidth } from "@/scripts/helpers/library";
import Accordion from "@/modules/containers/accordion";
import { starRating } from "@/scripts/helpers/jquery.star-rating-svg.js";
import Cookies from "js-cookie";
import { addedLazyLoadImages } from "@/scripts/helpers/imgLazyload";

export const tabsInit = (init, mode) => {
  const $window = $(window);
  const tabItem = $(".tab_content__item");
  const firstTabItem = $(".tab_content__item:first");
  const firstTabTitle = $(".tab__title:first");
  const firstTabList = $(".tabs-list__item:first");
  const tabListItem = $(".tabs-list__item");
  const firstTabBody = $(".tab__body:first");

  firstTabItem.show();
  firstTabList.addClass("is-active");

  firstTabItem.attr("aria-hidden", "false");
  firstTabList.attr("aria-selected", "true");

  tabListItem.on("click keyup", function() {
    tabItem.hide();
    tabItem.attr("aria-hidden", "true");

    const activeTab = $(this).attr("rel");
    $("#" + activeTab).fadeIn();
    $("#" + activeTab).attr("aria-hidden", "false");

    tabListItem.removeClass("is-active");
    tabListItem.attr("aria-selected", "false");
    $(this).addClass("is-active");
    $(this).attr("aria-selected", "true");
  });

  const panelTitle = $(".tab__title");
  const visibilityMode = mode || "single";
  const isInitialized = init || "init";
  const transitionTime = 170;

  if (isInitialized === "init") {
    const hidePanels = () => {
      const activeTitles = panelTitle.filter(function() {
        return $(this).attr("aria-selected") === "true";
      });

      $.each(activeTitles, function() {
        $(this).attr("aria-selected", "false");
        $(this)
          .next()
          .slideUp(transitionTime);
      });
    };

    $.each(panelTitle, function() {
      const isOpen = $(this).attr("aria-selected");

      if (isOpen === "true") {
        $(this)
          .next()
          .slideDown(transitionTime);
      } else {
        $(this)
          .next()
          .slideUp(transitionTime);
      }
    });

    if (visibilityMode === "single") {
      panelTitle.on("click", function() {
        const title = $(this);
        const panel = $(this).next();

        if (panel.length) {
          if (panel.is(":visible")) {
            $.each(panelTitle, function() {
              hidePanels();
            });
          } else {
            hidePanels();
            title.attr("aria-selected", "true");
            panel.slideDown(transitionTime);
          }
        }
      });
    } else if (visibilityMode === "multiply") {
      panelTitle.on("click", function() {
        const panel = $(this).next();

        if (panel.length) {
          panel.slideDown(transitionTime);
        } else {
          panel.slideUp(transitionTime);
        }
      });
    }
  } else {
    $(panelTitle).unbind("click");
  }
};

export const modalInit = () => {
  function showModal(el) {
    const tabletBreakpoint = 640;
    MicroModal.show(el, {
      awaitCloseAnimation: true,
      disableFocus: true,
      onShow: modal => {
        if ($(window).width() < tabletBreakpoint) stopBodyScrolling(true);
        $("body")
          .addClass("scroll-locked")
          .css("padding-right", getScrollBarWidth());
      },
      onClose: modal => {
        setTimeout(() => {
          if ($(window).width() < tabletBreakpoint) stopBodyScrolling(false);
          $("body")
            .removeClass("scroll-locked")
            .css("padding-right", 0);
        }, 250);
      }
    });
  }

  $(".js-modal-open").on("click", function(e) {
    e.preventDefault();
    showModal("modal-trial");
  });
};

export const linkShowText = () => {
  let showChar = 470,
    ellipsesText = "",
    moreText = "Read more",
    lessText = "Read less";

  $(".js-message-more").each(function() {
    let contentCollapseText = $(this).html();
    if (contentCollapseText.length > showChar) {
      let showText = contentCollapseText.substr(0, showChar),
        hideText = contentCollapseText.substr(
          showChar,
          contentCollapseText.length - showChar
        ),
        html =
          showText +
          ellipsesText +
          '</span><span class="more-content"><span>' +
          hideText +
          '</span><a target="#" tabindex="0" class="link js-link-show-text" aria-labelledby="form-description-show" href="#">' +
          moreText +
          "</a></span>";

      $(this).html(html);
    }
  });

  $(".js-link-show-text").on("click keydown", function(event) {
    event.preventDefault();
    const keycode = event.keyCode ? event.keyCode : event.which;
    if (event.shiftKey && event.keyCode === 9) {
      //set focus on previous element
      $(".bread-crumbs__link").focus();
    } else if (keycode === 9) {
      $(".block-support__column-actions .link").focus();
    }

    if (keycode === 13 || event.type === "click") {
      if ($(this).hasClass("less")) {
        $(this).removeClass("less");
        $(this).html(moreText);
      } else {
        $(this).addClass("less");
        $(this).html(lessText);
      }
      $(this)
        .parent()
        .prev()
        .toggle();
      $(this)
        .prev()
        .toggle();
    }
  });

  function updateLabel() {
    let tabActive = $(".js-signatures-select .tabs-list__item.is-active"),
      firstTab = $(".js-signatures-select .tabs-list__item:eq(0)"),
      selectLabel = $(".js-signatures-select .signatures-select__label");

    if (tabActive.length) {
      let contentHeader = tabActive.text();
      selectLabel.text(contentHeader);
    } else {
      let contentHeader = firstTab.text();
      selectLabel.text(contentHeader);
    }
  }
  updateLabel();

  $(".js-signatures-select").on("click", function() {
    $(this).toggleClass("is-open");
    updateLabel();
  });
};

export const ratingStar = () => {
  $(".js-form-template-rating").starRating({
    totalStars: 5,
    starShape: "rounded",
    starSize: 17,
    emptyColor: "#e2e2e2",
    hoverColor: "#ffd74c",
    activeColor: "#ffd74c",
    ratedColor: "#ffd74c",
    useGradient: false,
    useFullStars: true,
    disableAfterRate: false,
    forceRoundUp: true,
    callback: function(currentRating) {
      const formId = $("#form-id").val();
      if (!Cookies.get(`form_rating_${formId}`)) {
        $.ajax({
          url: "/forms/ajaxRatingFormTemplate",
          type: "POST",
          data: {
            star_input: currentRating,
            form_id: formId
          },
          dataType: "json",
          headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
          }
        });
        Cookies.set(`form_rating_${formId}`, currentRating);
      }
    }
  });
};

export const showCardsTemplates = () => {
  const tabletBreakpoint = 959,
    xlDesktopBreakpoint = 1480,
    windowWidth = $(window).width(),
    cardsTemplates = $(".cards"),
    lastCardTemplates = $(".card:last-child");

  if (cardsTemplates.length) {
    if (windowWidth > tabletBreakpoint && windowWidth < xlDesktopBreakpoint) {
      lastCardTemplates.remove();
    }
  }
};

const clampTextHandler = () => {
  $(".other-comparing-item__content").each(function() {
    let textItem = this.textContent;

    const desktopTextLimit = 34;
    const desktopWidth = 960;

    if (textItem.length > desktopTextLimit && $(window).width() >= desktopWidth) {
      let slicedText = this.textContent.slice(0,desktopTextLimit) + "..."
      this.textContent = slicedText;
    }

    const mobileTextLimit = 55;

    if (textItem.length > mobileTextLimit && $(window).width() <= desktopWidth - 1) {
      let slicedText = this.textContent.slice(0,mobileTextLimit) + "..."
      this.textContent = slicedText;
    }
  });
};

const formLoader = () => {
  const formButton = $(".js-editor-link");
  let ctaClickFlag = true;
  let loaderState = false;

  if (formButton.length) {
    formButton.on("click", function(event) {
      event.preventDefault();

      showLoader();
      resetScrollBar();

      if (ctaClickFlag) {
        ctaClickFlag = false;

        const formId = $(".page-section--content").attr("data-formId");
        const token = $("meta[name='csrf-token']").attr("content");

        $.ajax({
          url: "/forms/get-editor-data",
          type: "POST",
          data: {
            id: formId
          },
          dataType: "json",
          headers: { "X-CSRF-TOKEN": token },
          success: function(data) {
            let editorUrl = data.editorUrl;
            showLoader();
            const loader = document.querySelector(".js-form-loader");
            if (loader.classList.contains("is-show")) {
              loaderState = true;
            }
            resetScrollBar();
            setTimeout(() => {
              window.location.href = editorUrl;
            }, 700);
          }
        });
      }
    });
  }

  $(document).on("keydown keypress", function(e) {
    let charCode = e.charCode || e.keyCode || e.which;
    if (charCode === 27 && loaderState) {
      setTimeout(function() {
        window.location.reload(true);
      }, 200);
      return false;
    }

    if(charCode === 13 && loaderState) {
      return false;
    }
  });

  const showLoader = el => {
    const $loader = "#form-loader";
    let element = el || $loader;

    if ($(element).length) {
      $(element).addClass("is-show");
    }
    return true;
  };

  const detectScrollBar = () => {
    // Create the measurement node
    let scrollDiv = document.createElement("div");
    scrollDiv.className = "scrollbar-measure";
    document.body.appendChild(scrollDiv);

    // Get the scrollbar width
    let scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

    // Delete the DIV
    document.body.removeChild(scrollDiv);

    return scrollbarWidth;
  };

  const resetScrollBar = () => {
    const $body = $("body");
    let scrollWidth = detectScrollBar();

    $body.addClass("modal-open");
    if (scrollWidth > 0) {
      $body.css({ "padding-right": scrollWidth });
    }

    return false;
  };
};

const howToSignBlock = () => {
  const params = {
    howToSignSlider: $(".how-to-sign-slider"),
    statusHowToSign: $(".js-slide-counter-how"),
    sliderNavigationItem: $(".navigation-options__item"),
    sliderHiddenText: $(".sign-explanation-hidden-text"),
    sliderHiddenTextTrigger: $(".js-show-sign-explanation"),
    sliderVisibleTextTrigger: $(".js-hide-sign-explanation"),
    accordionTrigger: $(".how-to-sign-accordion-title"),
    accordionBody: ".page-section__row--how-to-sign",
    nextArrow: $(".js-how-to-sign-slider-arrow .btn-next-arrow"),
    prevArrow: $(".js-how-to-sign-slider-arrow .btn-prev-arrow"),
    signIllustration: $(".sign-illustration"),
    tabletBreakpoint: 1433,
    showMoreDescriptionLink: $(".sign-explanation__link"),
    showMoreDescription: $(".sign-explanation__description"),
    moreText: "Read more",
    lessText: "Read less"
  }

  // Slider

  params.howToSignSlider.on("init", function (currentSlide) {
    $(".carousel").addClass("is-visible");
    if (currentSlide) {
      $(this).find(".slick-current .js-how-to-sign-accordion-tablet").removeAttr("hidden");
    }
  });
  params.howToSignSlider.on("afterChange", function (currentSlide) {
    if (currentSlide) {
      $(".slick-slide .js-how-to-sign-accordion-tablet").attr("hidden", "hidden");
      $(this).find(".slick-current .js-how-to-sign-accordion-tablet").removeAttr("hidden");
    }
  });

  params.howToSignSlider.on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
    if (!slick.$dots) {
      return;
    }

    const counter = (currentSlide ? currentSlide : 0) + 1,
      sumCouner = slick.$dots[0].children.length;

    if (sumCouner < 10) {
      params.statusHowToSign.html("<b>0" + counter + "</b> " + "&nbsp;/&nbsp;0" + sumCouner);
    } else if (counter < 10) {
      params.statusHowToSign.html("<b>0" + counter + "</b> " + "&nbsp;/&nbsp;" + sumCouner);
    } else {
      params.statusHowToSign.html("<b>" + counter + "</b> " + "&nbsp;/&nbsp;" + sumCouner);
    }

    if (counter === 1) {
      params.prevArrow.addClass("is-disable");
      params.prevArrow.attr("tabindex", "-1");
    } else if (counter === sumCouner) {
      params.nextArrow.addClass("is-disable");
      params.nextArrow.attr("tabindex", "-1");
      params.prevArrow.removeClass("is-disable");
      params.prevArrow.removeAttr("tabindex", "-1");
    } else {
      params.nextArrow.removeClass("is-disable");
      params.nextArrow.removeAttr("tabindex", "-1");
      params.prevArrow.removeClass("is-disable");
      params.prevArrow.removeAttr("tabindex", "-1");
    }

  });

  params.howToSignSlider.slick({
    dots: true,
    arrows: false,
    infinite: false,
    speed: 300,
    adaptiveHeight: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: "ondemand",
    fade: true,
    responsive: [{
      breakpoint: 959,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }]
  });

  params.howToSignSlider.on("afterChange", function () {
    params.signIllustration.css("display", "block");
    params.showMoreDescription.removeClass("is-open");
    params.showMoreDescriptionLink.removeClass("less");
    params.showMoreDescriptionLink.html(params.moreText);
    $(".slick-list").removeClass("is-open");
    if ($(window).width() > params.tabletBreakpoint) {
      $(".how-to-sign-nav").css({top:""});
    }
  });
  params.howToSignSlider.on("beforeChange", function () {
    params.signIllustration.css("display", "none");
  });

  // Slider Navigation

  params.sliderNavigationItem.on("click focusin", function (e) {
    e.preventDefault();

    const slideIndex = $(this).index();
    params.howToSignSlider.slick("slickGoTo", parseInt(slideIndex));

    params.sliderNavigationItem.not(this).removeClass("is-active");
    params.sliderNavigationItem.not(this).attr("aria-selected", "false");
    $(this).addClass("is-active");
    $(this).attr("aria-selected", "true");
    params.sliderHiddenText.hide();
    params.sliderVisibleTextTrigger.show();
    params.sliderHiddenTextTrigger.show();

  });

  // AccordionMobile

  params.accordionTrigger.click(function () {

    const isOpen = $(this).next(params.accordionBody).is(":visible");
    if (isOpen === true) {
      params.accordionTrigger.next(params.accordionBody).slideUp(170);
      params.accordionTrigger.removeClass("is-active");
    } else {
      params.accordionTrigger.not(this).next(params.accordionBody).slideUp(170);
      $(this).next(params.accordionBody).slideDown(170);
      params.accordionTrigger.not(this).removeClass("is-active");
      $(this).addClass("is-active");
    }

    params.sliderHiddenText.hide();
    params.sliderHiddenTextTrigger.show();
    params.sliderVisibleTextTrigger.show();
  });

  params.nextArrow.click(function (e) {
    params.howToSignSlider.slick("slickNext");
  });
  params.prevArrow.click(function (e) {
    params.howToSignSlider.slick("slickPrev");
  });

  params.showMoreDescriptionLink.click(function (e) {
    e.preventDefault();
    $(this).prev(params.showMoreDescription).toggleClass("is-open");


    if ($(this).hasClass("less")) {
      $(this).removeClass("less");
      $(this).html(params.moreText);
      $(".slick-list").removeClass("is-open");
    } else {
      $(this).addClass("less");
      $(this).html(params.lessText);
      $(".slick-list").addClass("is-open");
    }
    const targetNav = $(this).prev((".sign-explanation__description.is-open")).outerHeight(true) + $(this).outerHeight(true) + $(this).prevAll((".sign-explanation__title")).outerHeight(true) + 68;

    if ($(window).width() > params.tabletBreakpoint) {
      $(".how-to-sign-nav").css("top", targetNav);
    }
  });

  // ShowText
  $(".js-show-sign-explanation").click(function (e) {
    e.preventDefault();
    $(this).parent().next(".sign-explanation-hidden-text").slideDown(170);
    $(this).hide();
    $(this).parent().next(".sign-explanation-hidden-text").show();
  });

  $(".js-show-sign-explanation").click(function () {
    $(this).closest().next(".sign-explanation-hidden-text").slideUp();
  });

  // HideText

  params.sliderVisibleTextTrigger.click(function (e) {
    e.preventDefault();

    params.sliderHiddenText.slideUp(170);
    $(this).hide()
    params.sliderHiddenTextTrigger.show();
  });

  $(".how-to-sign-nav").css("width", $(".sign-illustration").width());

  if ($(window).width() < params.tabletBreakpoint) {
    $(".js-how-to-sign-accordion-tablet").removeAttr("hidden");
    $(".how-to-sign-nav").css("top", $(".page-section__column--media").outerHeight(true));
  }

  $(window).resize(function () {
    $(".how-to-sign-nav").css("width", $(".sign-illustration").width());

    if ($(window).width() < params.tabletBreakpoint) {
      $(".how-to-sign-nav").css("top", $(".page-section__column--media").outerHeight(true));
    }
  });
}

$(document).ready(function() {
  initWowLibrary();
  addedLazyLoadImages();
  modalInit();
  Accordion();
  tabsInit();
  linkShowText();
  ratingStar();
  showCardsTemplates();
  clampTextHandler();
  formLoader();
  howToSignBlock();
});

const hideLoader = el => {
  const $body = $("body");
  const $loader = "#form-loader";
  let element = el || $loader;

  if ($(element).hasClass("is-show")) {
    $(element).removeClass("is-show");
  }

  if ($body.hasClass("modal-open")) {
    $body.removeClass("modal-open");
    $body.css({ "padding-right": 0 });
  }
  return true;
};

window.addEventListener("beforeunload", function() {
    hideLoader();
}, false);

window.addEventListener("pageshow", function(evt) {
    if (evt.persisted) {
      setTimeout(function() {
        window.location.reload();
      }, 10);
    }
}, false);
